//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Object.js";
import "../PDM/PDM.PdmSession.js";
let d=[[],[[["inputInfoPtr"],"AutoAssignPartParametersForCreate",{R_:{cliSpec:''}},1,0]],[]];
SPLM.PDM.PartNameGenerator = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PDM.PartNameGenerator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PartNameGenerator.PartAssignInputInfo = class{
    constructor(itemType,modelType,basePartNumber,basePartRevision,basePartName,generateNextItemId){
        this.itemType=itemType;this.modelType=modelType;this.basePartNumber=basePartNumber;this.basePartRevision=basePartRevision;this.basePartName=basePartName;this.generateNextItemId=generateNextItemId;}
    get Itemtype(){return this.itemType}
    set Itemtype(val){this.itemType = val}
    get Modeltype(){return this.modelType}
    set Modeltype(val){this.modelType = val}
    get Basepartnumber(){return this.basePartNumber}
    set Basepartnumber(val){this.basePartNumber = val}
    get Basepartrevision(){return this.basePartRevision}
    set Basepartrevision(val){this.basePartRevision = val}
    get Basepartname(){return this.basePartName}
    set Basepartname(val){this.basePartName = val}
    get Generatenextitemid(){return this.generateNextItemId}
    set Generatenextitemid(val){this.generateNextItemId = val}
};

export default SPLM;